// extracted by mini-css-extract-plugin
export default {"inner":"IkuC5","main":"EeC8i","actions":"OBzi_","action":"fuAcE"};